import styled, { css } from 'styled-components';

import { BREAKPOINTS, colors } from '../../../../common/styles/style-constants';

const getWidthByProps = (columns) => {
  const defaultWidth = 180;

  // There are 4 columns by default, so we divide 4 by the number of columns
  return `${4 / (columns || 4) * defaultWidth}px`;
};

const highlightedStyles = css`
  & + label {
    color: ${colors.sage7};
    border-color: ${colors.sage6};
    outline: none !important;
  }
`;

export const CheckboxContainer = styled.div`
  position: relative;
  margin-bottom: 5px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    display: inline-block;
    margin: 5px;
  }

  /* The guts of this styling */
  & > label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;
    cursor: pointer;
    padding: 16px 20px;
    color: ${(props) => (props.checked ? colors.sage7 : colors.darkCharcoal)};
    border-radius: 10px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
    background: ${(props) => (props.checked ? colors.lightSage : colors.white)};
    border: ${(props) =>
      (props.checked
        ? `1px solid ${colors.sage6}`
        : `1px solid ${colors.gray4}`)};
    transition: all 0.2s ease-in-out;

    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      ${(props) =>
        props.invisible
        && css`
          display: none;
        `}
    }

    @media (min-width: ${BREAKPOINTS.tabletMin}px) {
      flex-direction: column;
      justify-content: center;
      width: ${(props) => getWidthByProps(props.columns)};
      ${(props) =>
        props.invisible
        && css`
          visibility: hidden;
          display: flex;
        `}
      height: 100%;
      text-align: center;
      padding: 25px 15px;
    }
  }

  /* Hide checkbox */
  & > input[type='checkbox'] {
    /* Hide checkbox visually but remain accessible to screen readers. */
    /* Source: https://polished.js.org/docs/#hidevisually */
    border: 0;
    clip: rect(0 0 0 0);
    /* This is an invalid rule */
    /* clippath: inset(50%); */
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    /* Checkbox interaction triggers style updates */
    &:focus {
      ${highlightedStyles}
    }

    /* Only show hover styles when pointer is fine (mouse/trackpad) */
    /* Touchscreen hover gets stuck */
    @media (pointer: fine) {
      &:hover {
        ${highlightedStyles}
      }
    }

    &:active {
      & + label {
        color: ${colors.sage7};
        background: ${colors.lightSage};
        border-color: ${colors.sage6};
      }
    }
  }
`;
